export default "__VITE_ASSET__trvAqdj$__"